import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { TalkToSalesCTA } from 'purchase-motions-components/components/TalkToSalesCTA/TalkToSalesCTA';
import { usePurchaseMotions } from 'purchase-motions-components/hooks/usePurchaseMotions';
import { useGetInstallability } from 'marketplace-ui-install/install/hooks/useGetInstallability';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AgentUpgradeBanner({
  appContext,
  listingId,
  listingName,
  productType,
  published
}) {
  const {
    missingPlanApiName,
    userInstallable,
    portalInstallable
  } = useGetInstallability({
    listingId,
    appContext,
    published,
    productType
  });
  const {
    loading: talkToSalesMotionsLoading,
    purchaseMotions
  } = usePurchaseMotions({
    apiName: missingPlanApiName !== null && missingPlanApiName !== void 0 ? missingPlanApiName : '',
    location: 'TALK_TO_SALES_BUTTON'
  });
  const hasTalkToSalesMotion = !!missingPlanApiName && purchaseMotions.some(motion => motion === 'TALK_TO_SALES');
  if (userInstallable && portalInstallable || !missingPlanApiName || talkToSalesMotionsLoading || !hasTalkToSalesMotion) {
    return null;
  }
  const uniqueId = `agent-upgrade-banner-${listingName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}`;
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockEnd: "600",
    type: "info",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "400",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "100",
        children: [/*#__PURE__*/_jsx("h5", {
          style: {
            margin: 0
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.agentUpgradeBanner.title",
            options: {
              agentName: listingName
            }
          })
        }), /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          color: "text-core-default",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.agentUpgradeBanner.subtitle"
          })
        })]
      }), /*#__PURE__*/_jsx(TalkToSalesCTA, {
        apiName: missingPlanApiName,
        trackingData: {
          app: 'marketplace-details',
          screen: 'marketplace-listing-details',
          uniqueId
        },
        uiButtonProps: {
          use: 'primary',
          size: 'small',
          block: false
        }
      })]
    })
  });
}